import { render, staticRenderFns } from "./OptometryHistoryTable.vue?vue&type=template&id=b4fa3ad2&"
import script from "./OptometryHistoryTable.vue?vue&type=script&lang=js&"
export * from "./OptometryHistoryTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports